import {
  HttpClient,
  HttpErrorResponse,
  HttpResponse,
} from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import {
  Observable,
  catchError,
  distinctUntilChanged,
  firstValueFrom,
  map,
  of,
  switchMap,
  take,
  tap,
} from "rxjs";
import {
  ICancelarEntregable,
  IInfoVobo,
  INuevoTemaDespacho,
  IPorSeleccion,
  ITerminarEntregable,
  ITerminarSeguimiento,
} from "../../interfaces/despacho";
import {
  Database,
  equalTo,
  listVal,
  orderByChild,
  query,
  ref,
  push,
  set,
  get,
} from "@angular/fire/database";
import { TemasService } from "../temas/temas.service";

@Injectable({
  providedIn: "root",
})
export class DespachoService {
  constructor(
    private http: HttpClient,
    private database: Database,
    private temasService: TemasService
  ) {}
  
  public marcarParaImpresion : any[] = [];

  consultarTemasDespacho(): Observable<any> {
    return this.http
      .get<any>(`${environment.despacho.consultarTemasDespachoBeta}`)
      .pipe(
        tap((data) => console.log("API Response", data)),
        take(1),
        map((data: any) => {
          return data;
        }),
        catchError((error: HttpErrorResponse) => {
          console.error("Error en detalleAcuerdo", error);
          return of({ error: true, empresas: [] } as unknown as any);
        })
      );
  }

  getExcelEmpresa(payload: any): Observable<any> {
    return this.http
      .post(`${environment.despacho.getExcelEmpresa}`, payload, {
        headers: { "Content-Type": "application/json" },
        responseType: "arraybuffer",
      })
      .pipe(
        map((data: ArrayBuffer) => {
          console.log("data post", data);
          return data;
        }),
        catchError((error) => {
          console.log("error", error);

          return of({
            error: true,
            message: "No se encontrarón datos para esta consulta.",
          } as unknown as any);
        })
      );
  }
  getExcelInfoVobo(data: IInfoVobo): Observable<any> {
    return this.http
      .post(`${environment.despacho.getExcelInfoVoBo}`, data, {
        headers: { "Content-Type": "application/json" },
        responseType: "arraybuffer",
      })
      .pipe(
        tap((data) => console.log("API Response", data)),
        take(1),
        map((data: any) => {
          return data;
        }),
        catchError((error: any) => {
          return of({
            error: true,
            message: "No se encontrarón datos para esta consulta.",
          } as unknown as any);
        })
      );
  }

  getExcelSeleccion(data: IPorSeleccion): Observable<any> {
    return this.http
      .post(`${environment.despacho.getExcelSeleccion}`, data, {
        headers: { "Content-Type": "application/json" },
        responseType: "arraybuffer",
      })
      .pipe(
        map((data: any) => {
          console.log("data post", data);
          return data;
        }),
        catchError((error: any) => {
          return of({
            error: true,
            message: "No se encontrarón datos para esta consulta.",
          } as unknown as any);
        })
      );
  }

  getJustipfiicacion(tipo: string) {
    const refCatalogo = ref(this.database, `catalogos/${"justificacion"}`);
    return listVal(refCatalogo, { keyField: "id" });
  }

  getCatTipoFormaEnvio(cat: string): Observable<any> {
    return this.http.get(`${environment.catalogos}${cat}`).pipe(
      map((data: any) => {
        console.log("data getCatTipoFormaEnvio", data);
        return data;
      }),
      catchError((error: any) => {
        return of({
          error: true,
          message: "No se encontrarón datos para esta consulta.",
        } as unknown as any);
      })
    );
  }

  consultarTemaAMover(idTema: string, tipo: number): Observable<any> {
    return this.http
      .get(`${environment.despacho.consultarTemaAMover}/${idTema}/${tipo}`)
      .pipe(
        map((data: any) => {
          console.log("data consultarTemaAMover", data.tema[0]);
          return data.tema[0];
        }),
        catchError((error: any) => {
          return of({
            error: true,
            message: "No se encontrarón datos para esta consulta.",
          } as unknown as any);
        })
      );
  }

  getResponsablesFB(): Observable<any> {
    return this.http.get(`${environment.catalogos.consultaResponsables}`).pipe(
      map((data: any) => {
        return data;
      }),
      catchError((error: any) => {
        return of({
          error: true,
          message: "No se encontrarón datos para esta consulta.",
        } as unknown as any);
      })
    );
  }

  getCategoria(): Observable<any> {
    return this.http.get(`${environment.catalogos.getCatalogo}CATEGORIA`).pipe(
      map((data: any) => {
        return data;
      }),
      catchError((error: any) => {
        return of({
          error: true,
          message: "No se encontrarón datos para esta consulta.",
        } as unknown as any);
      })
    );
  }

  moverTemaDespachoAcuerdoMrB(payload: any): Promise<any> {
    return firstValueFrom(
      this.http.post(
        `${environment.despacho.moverTemaDespachoAcuerdoMrB }`,
        payload
      )
    );
  }

  quitarTema(payload: any): Promise<any> {
    return firstValueFrom(
      this.http.post(`${environment.despacho.quitarTema}`, payload)
    );
  }

  temaEliminado(payload: any): Promise<any> {
    return firstValueFrom(
      this.http.post(
        `${environment.acuerdos.notificacion}/despacho/temaEliminado`,
        payload
      )
    );
  }

  temaEliminadoMrb(payload: any): Promise<any> {
    return firstValueFrom(
      this.http.post(
        `${environment.acuerdos.notificacion}/mrb/temaEliminado`,
        payload
      )
    );
  }

  listarEntregables(id_tema: string): Observable<any> {
    return this.http
      .get(`${environment.despacho.listarEntregables}/${id_tema}`)
      .pipe(
        map((data: any) => {
          return data;
        }),
        catchError((error: any) => {
          return of({
            error: true,
            message: "Error al moverTemaDespachoAcuerdoMrB",
          } as unknown as any);
        })
      );
  }

  cancelarEntregables(payload: ICancelarEntregable): Promise<any> {
    return firstValueFrom(
      this.http.post(`${environment.despacho.cancelarEntregables}`, payload)
    );
  }

  listarEntradasConSeguimiento(id_tema: string): Observable<any> {
    return this.http
      .get(`${environment.despacho.listarEntradasConSeguimiento}/${id_tema}`)
      .pipe(
        map((data: any) => {
          return data;
        }),
        catchError((error: any) => {
          return of({
            error: true,
            message: "Error al listarEntradasConSeguimiento",
          } as unknown as any);
        })
      );
  }

  terminarSeguimiento(payload: ITerminarSeguimiento): Promise<any> {
    return firstValueFrom(
      this.http.post(`${environment.despacho.terminarSeguimiento}`, payload)
    );
  }

  listarEntregablesEnviadosAEjecucion(id_tema: string): Observable<any> {
    return this.http
      .get(
        `${environment.despacho.listarEntregablesEnviadosAEjecucion}/${id_tema}`
      )
      .pipe(
        map((data: any) => {
          return data;
        }),
        catchError((error: any) => {
          return of({
            error: true,
            message: "Error al listarEntradasConSeguimiento",
          } as unknown as any);
        })
      );
  }

  terminarEntregables(payload: ITerminarEntregable): Promise<any> {
    return firstValueFrom(
      this.http.post(`${environment.despacho.terminarEntregables}`, payload)
    );
  }

  agregarTemaDespacho(payload: INuevoTemaDespacho): Promise<any> {
    return firstValueFrom(
      this.http.post(`${environment.despacho.agregarTemaDespacho}`, payload)
    );
  }

  nuevoTema(payload: any): Promise<any> {
    return firstValueFrom(
      this.http.post(
        `${environment.acuerdos.notificacion}/despacho/nuevoTema`,
        { ...payload }
      )
    );
  }

  getInfoDespacho(): Observable<any> {
    return this.http.get(`${environment.despacho.getInfoDespacho}`).pipe(
      map((data: any) => {
        return data;
      }),
      catchError((error: any) => {
        return of({
          error: true,
          message: "Error en getInfoDespacho",
        } as unknown as any);
      })
    );
  }

  addImpresion(item: any) {
    if(!this.marcarParaImpresion.includes(item))
      this.marcarParaImpresion.push(item);
  }

  removeImpresion(item: any) {
    if(this.marcarParaImpresion.includes(item))
      this.marcarParaImpresion = this.marcarParaImpresion.filter(tema => tema !== item);
  }

  setImpresion(item: any[]) {
    this.marcarParaImpresion = item;
  }

  getImpresion() {
    return this.marcarParaImpresion;
  }

}
